import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable, DataTableFilterMeta, DataTableFilterMetaData } from "primereact/datatable";
import { Image } from 'primereact/image';
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useRef, useState } from "react";
import { useToast } from "../../../../../Shared/hook/useToast";
import { Banners } from "../../../Domain/Model/Banners";
import "../FormView.css";
import OffersPromoViewModel from "../OffersPromoViewModel";

interface ColumnMeta {
    field: string;
    header: string;
    editable: boolean;
}

export const BannerFormView = () => {

  const title = "Configuracion de banners - Home Page";
  const [webImage, setWebImage] = useState<File | null>(null);
  const [mobileImage, setMobileImage] = useState<File | null>(null);

  const [isDraggingWeb, setIsDraggingWeb] = useState(false);
  const [isDraggingMobile, setIsDraggingMobile] = useState(false);

  const webInputRef = useRef<HTMLInputElement>(null);
  const mobileInputRef = useRef<HTMLInputElement>(null);

  // const toast = useRef(null);
  const { showSuccess, showError, showWarn, showInfo } = useToast();

  // const [checkedStates, setCheckedStates] = useState<{ [key: string]: boolean }>({});

  const [totalRecords, setTotalRecords] = useState(0);

  const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});

   type LazyParamsType = {
        first: number;
        rows: number;
      };
      
  const [loading, setLoading] = useState(false);
  const [lazyParams, setLazyParams] = useState<LazyParamsType>({
      first: 0,
      rows: 10,
  });

  const [errors, setErrors] = useState({
    webImage: false,
    mobileImage: false
  });

  const columns: ColumnMeta[] = [
  { field: 'order', header: 'Orden', editable: true },
  { field: 'type', header: 'Tipo Oferta', editable: false },
  { field: 'imagePrimary', header: 'Previsualización', editable: false },
  { field: 'created', header: 'Fecha', editable: false },
  { field: 'status', header: 'Estado', editable: false },
  { field: 'options', header: 'Opciones', editable: false },
];


   const {
      getBanners,
      banners,
      createBanner,
      handleSwitchChange,
      updateTableBanner,
      removeBannerItemTable,
      checkedStates
    } = OffersPromoViewModel();


   useEffect(() => {
        // setItems(banners);
        
        console.log("Datos cargados:", banners);
  
     }, []);

    useEffect(() => {
        
        //ProductService.getProducts().then((data) => setProducts(data));
            // getProducts();
            const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
            loadBanners(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
        
    }, [lazyParams, filters]);


    const loadBanners = async (first: number, rows: number, search: string = '') => {
        setLoading(true);
        const page = Math.floor(first / rows);
        //const search = filters?.global?.value || '';

        console.log(page);

        try {
            const result = await getBanners(page+1, rows, search);
            console.log("Cargando página:", page, "con", rows, "elementos. Buscando:", search);
            
            setTotalRecords(result.totalCount);
          } catch (error) {
            console.error("Error al cargar Banners", error);
          } finally {
            setLoading(false);
          }
      };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>, type: "web" | "mobile") => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      type === "web" ? setWebImage(file) : setMobileImage(file);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, type: "web" | "mobile") => {
     const file = e.target.files?.[0];
  
  if (file) {
    // Validar tipo de archivo
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      showWarn("Error de formato", "Formato no válido. Por favor sube una imagen (PNG, JPG, JPEG, WEBP)");
      e.target.value = ''; // Limpiar input
      return;
    }
    
    // Validar tamaño máximo (ej: 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      showWarn("Error de tamaño", "La imagen es demasiado grande. Máximo permitido: 5MB");
      e.target.value = ''; // Limpiar input
      return;
    }
    
    type === "web" ? setWebImage(file) : setMobileImage(file);
    setErrors(prev => ({...prev, [type + 'Image']: false}));
  }
  };

// const show = (severity: any, summary: any, detail: any) => {
//       // @ts-ignore
//     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
// };

const handleSubmit = async (e: React.FormEvent) => {
   e.preventDefault();

  // Validación de imágenes
  const hasErrors = {
    webImage: !webImage,
    mobileImage: !mobileImage
  };

  setErrors(hasErrors);

  // Si hay errores, detener el envío
  if (hasErrors.webImage || hasErrors.mobileImage) {
    // Mostrar mensaje de error
    showError("Error al registrar", "Por favor, selecciona ambas imágenes (web y móvil)");

    // Simular foco en los campos inválidos (solución al error)
    if (hasErrors.webImage && webInputRef.current) {
      webInputRef.current.focus();
      setTimeout(() => webInputRef.current?.blur(), 100);
    }
    if (hasErrors.mobileImage && mobileInputRef.current) {
      mobileInputRef.current.focus();
      setTimeout(() => mobileInputRef.current?.blur(), 100);
    }
    
    return;
  }

  // Preparar FormData
  const formData = new FormData();
  formData.append("ImagePrimary", webImage as File);
  formData.append("ImageSecondary", mobileImage as File);

  try {
    console.log("Enviando imágenes...");
    const data = await createBanner(formData);

    if (data === true) {
      // Resetear formulario
      setWebImage(null);
      setMobileImage(null);
      
      // Resetear inputs de archivo
      if (webInputRef.current) webInputRef.current.value = '';
      if (mobileInputRef.current) mobileInputRef.current.value = '';
      
      // Recargar datos
      loadBanners(lazyParams.first ?? 1, lazyParams.rows ?? 10, "");
      showSuccess("Se registro", "Se subieron con éxito los banners");
    } else {
      showError("Error al registrar", "Error al subir las imágenes");
    }

  } catch (error) {
    console.error("Error al subir las imágenes", error);
    showError("Error al registrar", "Ocurrió un error al procesar las imágenes");
  }
};

  const confirmDelete = (id: any) => {

        confirmDialog({
            message: '¿Quieres eliminar este registro?',
            header: 'Eliminar confirmación',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel: 'No',
            accept: () => accept(id),
            reject
        });
    };

    
    const accept = async (id: string) => {
      
        let deleted = await removeBannerItemTable(Number(id));
        
        if(deleted){
          showInfo("Confirmada", "has aceptado!");
          const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
          loadBanners(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
          
        }      
    }
    const reject = () => {
          showWarn("Rechazada", "has rechazado!");
    }

  const btnOptions = (id: string)=> {

      // console.log(id.toString());
      return( 
          <div className="d-inline">
              <a href={`/banner-detail-form/${id}`} className="btn btn-dark">
                  <FontAwesomeIcon icon={icon({name: 'edit'})} />
              </a>&nbsp;
              <button type="button" onClick={()=>confirmDelete(id)}  className="btn btn-dark">
                  <FontAwesomeIcon icon={icon({name: 'trash'})} />
              </button> 
          </div>
      );
  };

  const typeOptions = (id: any)=> {
    let name: string = "";
        
        switch (id) {
            case 1:
                name = "Producto unico";
                break;
             case 2:
                name = "Lista";
                break;
            case 3:
                name = "Sin asignar";
                break;
            default:
                name = "";
                break;
        }
      return( 
          <div className="d-inline">
              {name}
          </div>
      );
  };

   const switchChange = async (checked: boolean, id: number, typeStateUpdate: string) => {

        try{
            await handleSwitchChange(checked, id, typeStateUpdate);
            showSuccess("Se Actualizo", "Se ha actualizado el estado con éxito!");
        }catch(error){
            showError("Error", "Error al actualizar!");
        }
    }

  const switchState = (value: Banners) => {
      // console.log("value: ", value.status);
      return (
        <>
          <div className="d-inline switchState">
            <InputSwitch
              checked={checkedStates[value.id]}
              onChange={(e) => switchChange(e.value, value.id, "banner")}
            />
          </div>
        </>
      );
    };

  const imgBanner = (data: Banners)=> {

        const image = data.imagePrimary;
        return(
            <>
              <Image className='img-pro' key={data.id +'pro'} src={image} alt="Image" width="100" />

            </>
        );
    }

  const formatDate = (value: string | Date): string => {
      let date: Date;
    
      if (typeof value === 'string') {
        // Limpiar si tiene fracción de segundos excesiva
        const cleaned = value.includes('.') ? value.split('.')[0] : value;
        date = new Date(cleaned);
      } else {
        date = value;
      }
    
      // Validar si es una fecha válida
      if (isNaN(date.getTime())) return 'Fecha inválida';
    
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
    
      return `${day}/${month}/${year}`;
    };


    // const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //         const value = event.target.value;
    //         const _filters: DataTableFilterMeta = {
    //             ...filters,
    //             global: {
    //               value,
    //               matchMode: 'contains', // <- tipo válido, no 'string' genérico
    //             },
    //           };
    
    //         setFilters(_filters);
    
    //          // Si está vacío, recarga productos
    //             if (!value.trim()) {
    //                 getBanners(lazyParams.first ?? 1, lazyParams.rows ?? 10, value);
    //             }
    //     };


            const isPositiveInteger = (val: any) => {
                let str = String(val);
        
                str = str.trim();
        
                if (!str) {
                    return false;
                }
        
                str = str.replace(/^0+/, '') || '0';
                let n = Math.floor(Number(str));
        
                return n !== Infinity && String(n) === str && n >= 0;
            };
        
            const onCellEditComplete = async (e: ColumnEvent) => {
                let { rowData, newValue, field, originalEvent: event } = e;

                // Evita disparar doble si no hubo cambio real
                if (rowData[field] === newValue) {
                    return;
                }
                switch (field) {
                    case 'order':
                        if (isPositiveInteger(newValue)) {
                          rowData[field] = newValue;
                        }
                        else {
                          event.preventDefault();
                          return;
                        }
                        break;
                    default:
                        if (newValue.trim().length > 0) {
                            rowData[field] = newValue;
                        }
                        else {
                          event.preventDefault();
                          return;
                        }
                        break;
                }
                const update = await updateTableBanner(rowData);
                if(update){
                  showSuccess("Se Actualizo", "Se ha actualizado el orden con éxito!");
                  const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
                  loadBanners(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
                }
            };


            const cellEditor = (options: ColumnEditorOptions) => {
                // if (options.field === 'state') return noTextEditor();
                // else return textEditor(options);
                return textEditor(options);
            };
        
            const textEditor = (options: ColumnEditorOptions) => {
                return (
                    <InputText
                        type="text"
                        value={options.value || ''} // Asegúrate de que options.value no sea nulo o indefinido
                        onChange={(e) => options.editorCallback!(e.target.value)} 
                    />
                );
            };
            

  // const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
  // const paginatorRight = <Button type="button" icon="pi pi-download" text />;

  return (
    <div className="container-fluid">
      <div className="block-header">
          <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                  <h2>Ofertas y promociones</h2>
                  <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                          <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                      </li>
                      <li className="breadcrumb-item">
                          <a href="/offers-promotions" className="text-danger">Ofertas y promociones</a>
                      </li>
                      <li className="breadcrumb-item">Configuracion de banners</li>
                  </ul>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="d-flex flex-row-reverse">
                      
                      <div className="p-2 d-flex">
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="row">
          <div className='title-report'>
          {title}
          </div>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
            <div className="card p-3">
              {/* <Toast ref={toast} /> */}
              <form onSubmit={handleSubmit} encType="multipart/form-data" className="form-container">
                <div
                  className={`dropzone ${isDraggingWeb ? 'drag-over-web' : ''} ${errors.webImage ? 'error-border' : ''}`}
                  onClick={() => webInputRef.current?.click()}
                  onDrop={(e) => {
                    handleDrop(e, "web");
                    setIsDraggingWeb(false);
                    setErrors(prev => ({...prev, webImage: false}));
                  }}
                  onDragOver={(e) => e.preventDefault()}
                  onDragEnter={() => setIsDraggingWeb(true)}
                  onDragLeave={() => setIsDraggingWeb(false)}
                >
                  {webImage ? (
                    <img src={URL.createObjectURL(webImage)} alt="web banner" />
                  ) : (
                    <>
                      <p className="size-banner">1904 X 650</p>
                      <span>Haz clic o arrastra aquí (Banner Web)</span>
                      {errors.webImage && <span className="error-message">Este campo es requerido</span>}
                      <span>solo valido (PNG,JPG,JPEG)</span>
                    </>
                  )}
                  <input
                    ref={webInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {handleChange(e, "web");setErrors(prev => ({...prev, webImage: false}));}}
                    name="ImagePrimary"
                  />
                </div>

                <div
                  className={`dropzone ${isDraggingMobile ? 'drag-over-mobile' : ''} ${errors.mobileImage ? 'error-border' : ''}`}
                  onClick={() => mobileInputRef.current?.click()}
                  onDrop={(e) => {
                    handleDrop(e, "mobile");
                    setIsDraggingMobile(false);
                    setErrors(prev => ({...prev, mobileImage: false}));
                  }}
                  onDragOver={(e) => e.preventDefault()}
                  onDragEnter={() => setIsDraggingMobile(true)}
                  onDragLeave={() => setIsDraggingMobile(false)}
                >
                  {mobileImage ? (
                    <img src={URL.createObjectURL(mobileImage)} alt="mobile banner" />
                  ) : (
                    <>
                      <p className="size-banner">901 X 1000</p>
                      <span>Haz clic o arrastra aquí (Banner Móvil)</span>
                      {errors.mobileImage && <span className="error-message">Este campo es requerido</span>}
                      <span>solo valido (PNG,JPG,JPEG)</span>
                    </>
                  )}
                  <input
                    ref={mobileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {handleChange(e, "mobile");setErrors(prev => ({...prev, webImage: false}));}}
                    name="ImageSecondary"
                  />
                </div>

                <button type="submit" className="btn btn-dark btn-form-banner">Guardar</button>
              </form>
            </div>
        </div>
      </div>
      <div className="col-lg-12 pt-4">
        {/* <Button label="Recargar" onClick={() => {
          const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
          loadBanners(lazyParams.first, lazyParams.rows, search);
        }} /> */}
         {/* <ConfirmDialog /> */}
          <DataTable 
            value={banners || []}
            lazy 
            paginator 
            rows={lazyParams.rows} 
            first={lazyParams.first} 
            totalRecords={totalRecords} 
            loading={loading} 
            editMode="cell" 
            rowsPerPageOptions={[5, 10, 15, 20]} 
            tableStyle={{ minWidth: '50rem' }} 
            onPage={(e) => setLazyParams({first: e.first, rows: e.rows})} 
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            // paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}  
            globalFilterFields={['order', 'type']} 
            emptyMessage="No se encontraron banners." stateStorage="session"
            // header={header} 
            filters={filters} 
            onFilter={(e) => {
              setFilters(e.filters); 
              // setLazyParams((prev) => ({ ...prev, first: 0 }));
              setLazyParams({ ...lazyParams, first: 0, rows: 1 });
            }}
            >
          {columns.map(({ field, header, editable  }) => {
                  return <Column 
                  key={field} 
                  field={field} 
                  header={header}
                  body={(rowData) => {
                      if (!rowData) return null; // Evitar errores si rowData es undefined
              
                      switch (field) {
                          case "type":
                            return typeOptions(rowData.type);
                          case "created":
                              return formatDate(String(rowData?.created ?? ""));
                          case "imagePrimary":
                              return imgBanner(rowData);
                          case "status":
                              return switchState(rowData);
                          case "options":
                              return (
                              <>
                                  {btnOptions(String(rowData.id))}
                                  
                              </>
                          );
                        default:
                          return rowData[field]; // Mostrar el valor del campo en caso de no ser especial
                      }
                    }}

                  editor={editable ? (options) => cellEditor(options) : undefined} 
                  onCellEditComplete={onCellEditComplete}
                 />
          })
        }
      </DataTable>
      </div>
    </div>
  );
}